import { jsxs, jsx } from 'react/jsx-runtime';
import formatDatetime from '../../intl/dateTime/formatDateTime.js';
import 'react';
import 'styled-components';
import '../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import '../../theme/ThemedComponentWrapper.js';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowSwitchIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import './Input/Input.js';
import './ToggleSwitch.js';
import './Table/Table.js';
import './Table/components/HeaderCell/HeaderCell.js';
import Tooltip from './Tooltip/Tooltip.js';
import TooltipContent from './Tooltip/components/TooltipContent.js';
import TooltipTrigger from './Tooltip/components/TooltipTrigger.js';
import './Table/components/Pagination/Pagination.js';
import './layout/Stack/Stack.js';
import 'luxon';
import '../molecules/CurrencyValue/components/Value.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import '../molecules/TrendValue.js';
import '../molecules/KpiCard/KpiCard.js';
import '../molecules/Tabs/Tabs.js';
import '../charts/ChartKpis/ChartKpi.js';
import '../charts/ChartJS.js';
import '../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../XRay.js';
import 'ethereum-blockies-base64';

function RelativeDateTime({ value, ...tooltipOptions }) {
    return (jsxs(Tooltip, { ...tooltipOptions, children: [jsx(TooltipTrigger, { variant: "nowrap", children: formatDatetime(value, { toRelative: true }) }), jsx(TooltipContent, { children: formatDatetime(value, { showTime: true }) })] }));
}

export { RelativeDateTime as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVsYXRpdmVEYXRlVGltZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYXRvbXMvUmVsYXRpdmVEYXRlVGltZS50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVG9vbHRpcE9wdGlvbnMgfSBmcm9tICcuL1Rvb2x0aXAvVG9vbHRpcCc7XG5pbXBvcnQgeyBmb3JtYXREYXRldGltZSB9IGZyb20gJy4uLy4uL2ludGwnO1xuaW1wb3J0IHsgVG9vbHRpcCwgVG9vbHRpcENvbnRlbnQsIFRvb2x0aXBUcmlnZ2VyIH0gZnJvbSAnQGF0b21zJztcblxuZXhwb3J0IGludGVyZmFjZSBSZWxhdGl2ZURhdGVUaW1lUHJvcHMgZXh0ZW5kcyBUb29sdGlwT3B0aW9ucyB7XG4gIHZhbHVlOiBzdHJpbmcgfCBudW1iZXI7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFJlbGF0aXZlRGF0ZVRpbWUoe1xuICB2YWx1ZSxcbiAgLi4udG9vbHRpcE9wdGlvbnNcbn06IFJlbGF0aXZlRGF0ZVRpbWVQcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxUb29sdGlwIHsuLi50b29sdGlwT3B0aW9uc30+XG4gICAgICA8VG9vbHRpcFRyaWdnZXIgdmFyaWFudD1cIm5vd3JhcFwiPlxuICAgICAgICB7Zm9ybWF0RGF0ZXRpbWUodmFsdWUsIHsgdG9SZWxhdGl2ZTogdHJ1ZSB9KX1cbiAgICAgIDwvVG9vbHRpcFRyaWdnZXI+XG5cbiAgICAgIDxUb29sdGlwQ29udGVudD5cbiAgICAgICAge2Zvcm1hdERhdGV0aW1lKHZhbHVlLCB7IHNob3dUaW1lOiB0cnVlIH0pfVxuICAgICAgPC9Ub29sdGlwQ29udGVudD5cbiAgICA8L1Rvb2x0aXA+XG4gICk7XG59XG4iXSwibmFtZXMiOlsiX2pzeHMiLCJfanN4Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFRYyxTQUFVLGdCQUFnQixDQUFDLEVBQ3ZDLEtBQUssRUFDTCxHQUFHLGNBQWMsRUFDSyxFQUFBO0FBQ3RCLElBQUEsUUFDRUEsSUFBQyxDQUFBLE9BQU8sT0FBSyxjQUFjLEVBQUEsUUFBQSxFQUFBLENBQ3pCQyxJQUFDLGNBQWMsRUFBQSxFQUFDLE9BQU8sRUFBQyxRQUFRLEVBQzdCLFFBQUEsRUFBQSxjQUFjLENBQUMsS0FBSyxFQUFFLEVBQUUsVUFBVSxFQUFFLElBQUksRUFBRSxDQUFDLEVBQzdCLENBQUEsRUFFakJBLElBQUMsY0FBYyxFQUFBLEVBQUEsUUFBQSxFQUNaLGNBQWMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLENBQUMsRUFDM0IsQ0FBQSxDQUFBLEVBQUEsQ0FDVCxFQUNWO0FBQ0o7Ozs7In0=
